import { useEffect, useRef, useState } from 'react'
import { Alert, Card } from 'reactstrap'

// components
import ICUpload from 'assets/icons/ic-upload.svg'
import ICXAlert from 'assets/icons/ic-x-alert.svg'

import { useDispatch } from 'react-redux'
import { uploadImage } from './employeePaymentsAction'
import { updateDisbursementProofImg } from './employeePaymentsListSlice'

const CardUploadImage = ({
  type,
  disbursementIndex,
  employeeUserId,
  ...args
}) => {
  const dispatch = useDispatch()
  const fileInputRef = useRef(null)
  const [dataImg, setDataImg] = useState(null)
  const [previewImage, setPreviewImage] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const [visibleErrorMsg, setVisibleErrorMsg] = useState(false)
  const [visiblePreviewImg, setVisiblePreviewImg] = useState(false)

  useEffect(() => {
    return () => {
      resetState()
    }
  }, [type, disbursementIndex])

  const resetState = () => {
    setDataImg(null)
    setPreviewImage(null)
    setErrorMessage(null)
    setVisibleErrorMsg(false)
    setVisiblePreviewImg(false)
  }

  const onDismissPreviewImg = () => {
    setPreviewImage(null)
    setVisiblePreviewImg(false)
    setDataImg(null)
  }

  const fnCloseErrorMsg = () => {
    setVisibleErrorMsg(false)
    setErrorMessage(null)
  }

  const handleUploadClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = (event) => {
    fnCloseErrorMsg()
    onDismissPreviewImg()

    const file = event.target.files[0]

    if (file === undefined) {
      setDataImg(null)
      setErrorMessage('Anda belum menambahkan foto.')
      return
    }

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
    if (!allowedTypes.includes(file.type)) {
      setVisibleErrorMsg(true)
      return setErrorMessage(`Hanya file JPG dan PNG yang diperbolehkan.`)
    }

    const maxSizeMB = 4
    const maxSizeBytes = maxSizeMB * 1024 * 1024
    if (file.size > maxSizeBytes) {
      setVisibleErrorMsg(true)
      return setErrorMessage(`Ukuran file melebihi batas ${maxSizeMB}MB.`)
    }

    const reader = new FileReader()
    reader.onload = () => {
      setPreviewImage(reader.result)
      setVisiblePreviewImg(true)
    }
    reader.readAsDataURL(file)
    setDataImg(file)

    event.target.value = null
    fnUploadFile(file)
  }

  const fnUploadFile = async (dataImg) => {
    if (dataImg === null) {
      setErrorMessage('Anda belum menambahkan foto.')
      setVisibleErrorMsg(true)
      setPreviewImage(null)
      return
    }

    try {
      const data = await dispatch(
        uploadImage({ img: dataImg, fileType: type }),
      ).unwrap()

      if (data?.error) {
        setErrorMessage(data?.payload)
        setVisibleErrorMsg(true)
        setPreviewImage(null)
      } else if (type?.startsWith('PAYMENT_PROOF_') && data?.url) {
        if (disbursementIndex !== undefined && disbursementIndex !== null) {
          dispatch(
            updateDisbursementProofImg({
              index: disbursementIndex,
              proofImgs: data?.url,
            }),
          )
        }
      }
    } catch (error) {
      setErrorMessage(
        error?.data?.message ||
          error?.data?.meta?.message ||
          error?.message ||
          'Upload gagal',
      )
      setVisibleErrorMsg(true)
      setPreviewImage(null)
    }
  }

  return (
    <Card {...args} style={{ boxShadow: 'none' }}>
      {/* Error message */}
      {errorMessage !== null && (
        <Alert
          isOpen={visibleErrorMsg}
          toggle={fnCloseErrorMsg}
          color="danger"
          className="d-flex align-items-center gap-2 my-4"
        >
          <img src={ICXAlert} alt="alert icon" width={18} height={18} />
          <span>{errorMessage}</span>
        </Alert>
      )}
      {/* Image previewImage */}
      {previewImage !== null ? (
        <Alert
          className="p-3 my-4 d-flex justify-content-center align-items-center"
          isOpen={visiblePreviewImg}
          toggle={onDismissPreviewImg}
          style={{ backgroundColor: 'transparent', border: 'none' }}
          color="secondary"
        >
          <img
            src={previewImage}
            alt="Preview"
            style={{ maxWidth: '20rem', maxHeight: '20rem' }}
          />
        </Alert>
      ) : (
        <Card
          className="p-3 d-flex justify-content-center align-items-center"
          onClick={() => {
            handleUploadClick()
          }}
          style={{ cursor: 'pointer', boxShadow: 'none' }}
          data-testid="emp-pay-upload-card"
        >
          <img src={ICUpload} alt="icon" width={50} height={50} />
          <span className="text-primary fw-bolder">Click for upload</span>
          <span className="text-sm">{`JPG or PNG`}</span>
        </Card>
      )}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        accept=".jpg, .png"
      />
    </Card>
  )
}

export default CardUploadImage
